import { PUBLIC_DIFFUSION_API_ENDPOINT } from '$env/static/public';
import {
	Client as DiffusionApiClient,
	type Board,
	type BoardImagePin,
	type GetBoardImagesResponse
} from '$lib/diffusionApi';

export class BoardsClient {
	private diffusionApiClient: DiffusionApiClient;

	constructor(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public setToken(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public async getBoard(boardId: string): Promise<Board | undefined> {
		const response = await this.diffusionApiClient.default.getBoardBoardGet(boardId);
		return response.board;
	}

	public async getBoards(): Promise<Board[]> {
		const response = await this.diffusionApiClient.default.getBoardsBoardsGet();
		return response.boards;
	}

	public async createBoard(name: string): Promise<Board | undefined> {
		try {
			const response = await this.diffusionApiClient.default.createBoardBoardPost({
				name
			});
			return response.board;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}

	public async patchBoard(boardId: string, newName: string): Promise<Board | undefined> {
		try {
			const response = await this.diffusionApiClient.default.patchBoardBoardPatch({
				board_id: boardId,
				name: newName
			});
			return response.board;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}

	public async deleteBoard(boardId: string): Promise<undefined> {
		try {
			await this.diffusionApiClient.default.deleteBoardBoardDelete({
				board_id: boardId
			});
		} catch (error) {
			console.error(error);
		}
	}

	public async getBoardImagePins(board_id?: string): Promise<BoardImagePin[] | undefined> {
		try {
			const response = await this.diffusionApiClient.default.getBoardImagePinsBoardImagePinsGet(
				board_id
			);
			return response.board_image_pins;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}

	public async createBoardImagePin(data: {
		board_id: string;
		generation_id?: string;
		upload_id?: string;
	}): Promise<BoardImagePin | undefined> {
		try {
			const response = await this.diffusionApiClient.default.createBoardImagePinBoardImagePinPost(
				data
			);
			return response.board_image_pin;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}

	public async deleteBoardImagePin(data: {
		board_id: string;
		generation_id?: string;
		upload_id?: string;
	}): Promise<undefined> {
		try {
			await this.diffusionApiClient.default.deleteBoardImagePinBoardImagePinDelete(data);
		} catch (error) {
			console.error(error);
		}
	}

	public async getBoardImages(board_id: string): Promise<GetBoardImagesResponse | undefined> {
		try {
			return await this.diffusionApiClient.default.getBoardImagesBoardImagesGet(board_id);
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}
}
